export class Attachemnt {
	constructor(
		public requirementid?: number,
		public note?: string,
		public attachments?: Array<any>,
	) { }
}